import React from 'react';
import { MetadataProps } from '@osmosis/shared/types/learn';
import TwitterMetaData from './metadata/TwitterMetaData';
import HtmlMetaData from './metadata/HtmlMetaData';
import OpenGraphMetaData from './metadata/OpenGraphMetaData';
import HeaderTitle from './HeaderTitle';

type Props = MetadataProps;

/**
 * Metadata component.
 */
const Metadata = (props: Props) => {
  return (
    <>
      <HeaderTitle title={props.title} />
      <HtmlMetaData {...props} />
      <OpenGraphMetaData {...props} />
      <TwitterMetaData {...props} />
    </>
  );
};

export default Metadata;
